<div class="sheet-picker" data-testid="sheet-picker">
  <section class="sheet-list" aria-label="Sheets" (scroll)="onListScroll($event)">
    <!-- W49: the drawings register's search bar -->
    <div class="search" data-testid="sheet-picker-search-bar">
      <mat-icon svgIcon="search" aria-hidden="true"></mat-icon>
      <input type="text" class="search-input" data-testid="sheet-picker-search" maxlength="256" placeholder="Search number, title or STA 1018+50"
        aria-label="Search sheets" [value]="query" (input)="onSearch($any($event.target).value)" />
      @if (query) {
        <mat-icon svgIcon="close" role="button" aria-label="Clear the search" data-testid="sheet-picker-search-clear" (click)="clearSearch()"></mat-icon>
      }
    </div>
    @if (nearStation) {
      <p class="text-type-13 sheet-secondary" data-testid="sheet-picker-near">Sheets at this station</p>
    }
    @if (loadingSheets && !sheets.length) {
      <div class="sheet-status"><mat-spinner diameter="24" aria-label="Loading sheets" /></div>
    } @else if (listError) {
      <div class="sheet-list-error" role="alert" data-testid="sheet-picker-error">
        <p class="text-type-14 sheet-error">{{ listError }}</p>
        <button type="button" class="sheet-retry" data-testid="sheet-picker-retry" (click)="retryList()">Retry</button>
      </div>
    } @else if (!sheets.length) {
      <p class="text-type-14 sheet-secondary" role="status">{{ query ? 'No sheets match.' : 'No published sheets yet.' }}</p>
    }
    <ul class="sheet-rows">
      @for (sheet of sheets; track sheet.uuid) {
        <li>
          <button type="button" class="sheet-row" data-testid="sheet-picker-row" [class.selected]="sheet.uuid === selectedSheetUuid"
            [attr.aria-pressed]="sheet.uuid === selectedSheetUuid" (click)="choose(sheet)">
            <!-- W75: the register's thumbnail (lazy, cover, hairline box; an empty box when there is none) -->
            @if (sheet.current?.thumb_url) {
              <img class="sheet-row-thumb" data-testid="sheet-picker-row-thumb" [src]="sheet.current.thumb_url" [alt]="sheet.number + ' thumbnail'"
                loading="lazy" draggable="false" />
            } @else {
              <span class="sheet-row-thumb" data-testid="sheet-picker-row-thumb-empty" aria-hidden="true"></span>
            }
            <span class="sheet-row-text">
              <span class="sheet-row-number">{{ sheet.number }}</span>
              <span class="sheet-row-detail">{{ sheetDetail(sheet) }}</span>
            </span>
          </button>
        </li>
      }
    </ul>
    <!-- Audit 1: the rest of the register, 100 at a time (scrolling near the end loads it too) -->
    @if (loadingMore) {
      <div class="sheet-status" data-testid="sheet-picker-more-loading"><mat-spinner diameter="20" aria-label="Loading more sheets" /></div>
    } @else if (moreError) {
      <div class="sheet-list-error" role="alert" data-testid="sheet-picker-more-error">
        <p class="text-type-14 sheet-error">{{ moreError }}</p>
        <button type="button" class="sheet-retry" data-testid="sheet-picker-more-retry" (click)="loadMore()">Retry</button>
      </div>
    } @else if (hasMoreSheets && !listError) {
      <button type="button" class="sheet-retry sheet-more" data-testid="sheet-picker-more" (click)="loadMore()">Show more sheets</button>
    }
  </section>

  <section class="sheet-preview" aria-label="Sheet">
    @if (revision) {
      <div class="sheet-toolbar">
        <div class="sheet-toolbar-text">
          <div class="sheet-title" data-testid="sheet-picker-title" [attr.title]="revisionTitle">{{ revisionTitle }}</div>
          <div class="text-type-13 sheet-secondary">
            @if (revisionBadge) { <span class="sheet-badge" data-testid="sheet-picker-badge">{{ revisionBadge }}</span> · }
            {{ !imageLoaded ? 'Loading sheet…' : point ? 'Drag the pin or click elsewhere to move it' : 'Click the sheet to drop a pin, or mark it up' }}
          </div>
        </div>
        <button type="button" class="sheet-markup mat-subtitle-1" data-testid="sheet-picker-markup" [disabled]="!imageLoaded || !canMarkUp"
          (click)="askMarkUp()">{{ hasMarkup && (!link?.sheet || revision.uuid === link.sheet.revision_uuid) ? 'Edit markup' : 'Mark up' }}</button>
      </div>
      <!-- W75: as the sheet viewer: pinch / ctrl + wheel zoom the sheet at the cursor, wheel and drag pan, the map-style stack bottom-right -->
      <div class="sheet-stage">
      <div #sheetScroll class="sheet-scroll" data-testid="sheet-picker-scroll" [class.sheet-scroll--zoomed]="zoom > 1" [class.sheet-scroll--panning]="panning"
        (pointerdown)="onScrollPointerDown($event)" (pointermove)="onScrollPointerMove($event)" (pointerup)="onScrollPointerUp($event)"
        (pointercancel)="onScrollPointerUp($event)" (lostpointercapture)="onScrollCaptureLost()">
        <!-- The image keeps the page's aspect (no object-fit), so a click's offset over its size is the point on the page. -->
        <div class="sheet-frame" [style.width.%]="zoom * 100">
          <!-- Keyboard: Enter places the point at the centre, the arrow keys move it. -->
          <img #sheetImage class="sheet-image" data-testid="sheet-picker-image" [src]="revision.preview_url || revision.thumb_url" [alt]="revisionTitle"
            tabindex="0" role="button" aria-label="Place the point on the sheet. Arrow keys move it." draggable="false"
            [class.sheet-image--loading]="!imageLoaded" (load)="onImageLoad()" (click)="place($event)" (keydown)="onImageKey($event)" />
          @if (showMarkupOverlay) {
            <img class="sheet-markup-overlay" data-testid="sheet-picker-markup-overlay" [src]="markupOverlay" alt="" aria-hidden="true" draggable="false" />
          }
          @if (point) {
            <img class="sheet-pin" data-testid="sheet-picker-pin" src="/assets/icons/map/markers/location-pin-filled.svg" alt="" draggable="false"
              [class.sheet-pin--dragging]="pinDragging" [style.left.%]="point.x * 100" [style.top.%]="point.y * 100"
              (pointerdown)="onPinDown($event)" (pointermove)="onPinMove($event)" (pointerup)="onPinUp($event)" (pointercancel)="onPinUp($event)" />
            @if (pinMenuOpen) {
              <!-- Audit 2: the pin's menu (a click on the pin): Remove pin; the dialog asks first when markup would go -->
              <div class="pin-menu" data-testid="sheet-picker-pin-menu" role="menu" aria-label="Pin"
                [style.left.%]="point.x * 100" [style.top.%]="point.y * 100" (keydown.escape)="pinMenuOpen = false">
                <button type="button" role="menuitem" class="pin-menu-item" data-testid="sheet-picker-remove-pin" (click)="askRemovePin()">Remove pin</button>
              </div>
            }
          }
        </div>
      </div>
      <app-sheet-zoom-controls testIdPrefix="sheet-picker" [zoom]="zoom" [canZoomIn]="canZoomIn && imageLoaded" [canZoomOut]="canZoomOut"
        (zoomIn)="zoomBy(1)" (zoomOut)="zoomBy(-1)" />
      </div>
    } @else if (loadingRevision) {
      <div class="sheet-status"><mat-spinner diameter="32" aria-label="Loading the sheet" /></div>
    } @else if (revisionError) {
      <p class="text-type-14 sheet-error sheet-empty" role="alert">{{ revisionError }}</p>
    } @else {
      <p class="text-type-14 sheet-secondary sheet-empty">Choose a sheet, then click the spot on it.</p>
    }
  </section>
</div>
